
import { LucideIcon, ChevronDown } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

interface CategoryButtonProps {
  icon: LucideIcon;
  label: string;
  isActive?: boolean;
  isExpanded?: boolean;
  onClick?: () => void;
}

export const CategoryButton = ({
  icon: Icon,
  label,
  isActive,
  isExpanded,
  onClick,
}: CategoryButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`flex flex-col items-center gap-1.5 p-2 rounded-xl transition-all w-full ${
        isActive
          ? "bg-primary text-white"
          : "bg-white text-gray-600"
      }`}
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = 'var(--brand-color-5, #F5FBEF)';
          e.currentTarget.style.color = '#374151';
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = 'white';
          e.currentTarget.style.color = '#6b7280';
        }
      }}
    >
      <Icon className="w-5 h-5" />
      <div className="flex items-center gap-1">
        <span className="text-xs font-medium">{label}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${isExpanded ? "rotate-180" : ""}`} />
      </div>
    </button>
  );
};

export const CategoryButtonSkeleton = () => {
  return (
    <div className="flex flex-col items-center gap-1.5 p-2 rounded-xl bg-white w-full">
      <Skeleton className="w-5 h-5 rounded-full" />
      <Skeleton className="w-16 h-3 rounded" />
    </div>
  );
};
